import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";

import vastuImg from "../../assets/IMG02.png";
import astroImg from "../../assets/IMG05.png";
import numeroImg from "../../assets/IMG01.png";
import prakritiImg from "../../assets/IMG09.png";
import designImg from "../../assets/IMG07.png";
import palmistryImg from "../../assets/IMG10.jpeg";

const services = [
  { title: "Vastu Report",     subtitle: "Space & Energy Analysis",     path: "/vastu",           image: vastuImg     },
  { title: "Astro Advice",     subtitle: "Vedic Birth Chart Reading",   path: "/astro",           image: astroImg     },
  { title: "Numero Advice",    subtitle: "Name & Number Alignment",     path: "/numerology",      image: numeroImg    },
  { title: "Prakriti Advice",  subtitle: "Know Your Natural Energy",    path: "/prakriti",        image: prakritiImg  },
  { title: "Design Advice",    subtitle: "Horoscope Based Home Design", path: "/design",          image: designImg    },
  { title: "Palmistry Advice", subtitle: "Palm & Astrology Guidance",   path: "/palmistry-astro", image: palmistryImg },
];

const Hero = () => {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=Montserrat:wght@500;600&family=Lato:wght@300;400&display=swap');

        .hero-section {
          background-color: #fdf8f0;
          background-image:
            radial-gradient(ellipse at 10% 20%, rgba(130,94,10,0.07) 0%, transparent 50%),
            radial-gradient(ellipse at 90% 80%, rgba(196,138,20,0.06) 0%, transparent 50%);
          padding: 64px 0 80px;
          position: relative;
        }
        .hero-section::before {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0;
          height: 3px;
          background: linear-gradient(to right, transparent, #c48a14, #f0c060, #c48a14, transparent);
          opacity: 0.45;
        }

        .card-link {
          text-decoration: none;
          display: block;
        }

        /* Card shell — no fixed aspect ratio, image drives height */
        .hero-card {
          position: relative;
          border-radius: 14px;
          overflow: hidden;
          box-shadow: 0 6px 24px rgba(130,94,10,0.12);
          transition: transform 0.35s ease, box-shadow 0.35s ease;
          background: #2c1a00;
        }
        .hero-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 18px 48px rgba(130,94,10,0.22);
        }

        /* Image — responsive heights per breakpoint */
        .hero-card-img {
          width: 100%;
          display: block;
          object-fit: cover;
          object-position: top center;
          opacity: 0.85;
          transition: opacity 0.35s ease, transform 0.35s ease;

          /* Mobile default: cap tall portraits */
          height: 72vw;
          max-height: 420px;
        }
        .hero-card:hover .hero-card-img {
          opacity: 0.65;
          transform: scale(1.04);
        }

        /* Tablet 2-col */
        @media (min-width: 576px) {
          .hero-card-img { height: 52vw; max-height: none; }
        }

        /* Desktop 3-col */
        @media (min-width: 992px) {
          .hero-card-img { height: 360px; }
          .hero-section  { padding: 64px 0 80px; }
        }

        /* Overlay pinned over image */
        .hero-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
            to top,
            rgba(44,26,0,0.92) 0%,
            rgba(44,26,0,0.25) 45%,
            transparent 100%
          );
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          padding: 20px 20px 22px;
          transition: background 0.35s ease;
        }
        .hero-card:hover .hero-overlay {
          background: linear-gradient(
            to top,
            rgba(44,26,0,0.97) 0%,
            rgba(44,26,0,0.55) 55%,
            rgba(130,94,10,0.08) 100%
          );
        }

        /* Text block */
        .hero-text-wrap { position: relative; }

        .hero-text-wrap::before {
          content: '';
          display: block;
          width: 28px; height: 2px;
          background: linear-gradient(to right, #c48a14, #f0c060);
          border-radius: 2px;
          margin-bottom: 8px;
          transition: width 0.35s ease;
        }
        .hero-card:hover .hero-text-wrap::before { width: 44px; }

        .hero-title {
          font-family: 'Playfair Display', serif;
          font-size: 19px; font-weight: 700;
          color: #f0c060;
          margin: 0 0 4px; line-height: 1.25;
        }

        .hero-subtitle {
          font-family: 'Lato', sans-serif;
          font-size: 12px; color: rgba(253,248,240,0.6);
          font-weight: 300; letter-spacing: 0.4px;
          margin: 0 0 10px;
          opacity: 0; transform: translateY(6px);
          transition: opacity 0.3s ease 0.05s, transform 0.3s ease 0.05s;
        }
        .hero-card:hover .hero-subtitle { opacity: 1; transform: translateY(0); }

        .hero-cta {
          display: inline-flex; align-items: center; gap: 6px;
          font-family: 'Montserrat', sans-serif;
          font-size: 11px; font-weight: 600;
          color: rgba(253,248,240,0.45);
          letter-spacing: 1.5px; text-transform: uppercase;
          opacity: 0; transform: translateY(6px);
          transition: opacity 0.3s ease 0.1s, transform 0.3s ease 0.1s;
        }
        .hero-card:hover .hero-cta { opacity: 1; transform: translateY(0); }
        .hero-cta::after { content: '→'; font-size: 13px; color: #c48a14; }

        @media (max-width: 575px) {
          .hero-section { padding: 40px 0 56px; }
          .hero-title { font-size: 17px; }
        }
      `}</style>

      <section className="hero-section">
        <Container>
          <Row className="g-4">
            {services.map((item, index) => (
              <Col key={index} xs={12} sm={6} lg={4}>
                <Link to={item.path} className="card-link">
                  <div className="hero-card">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="hero-card-img"
                    />
                    <div className="hero-overlay">
                      <div className="hero-text-wrap">
                        <div className="hero-title">{item.title}</div>
                        <div className="hero-subtitle">{item.subtitle}</div>
                        <div className="hero-cta">Explore</div>
                      </div>
                    </div>
                  </div>
                </Link>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Hero;